var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 40,
    viewBox: "0 0 87 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1549_2916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.94141,
    y: 0.725098,
    width: 81.1667,
    height: 33.7154,
    rx: 6.24359,
    fill: "#EF7D00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3148 21.1902C23.3967 21.1902 22.2479 20.0814 22.2479 18.0435V14.0975H23.5466V17.9935C23.5466 19.432 24.1959 20.0514 25.3247 20.0514C26.4536 20.0514 27.0929 19.432 27.0929 17.9935V14.0975H28.3716V18.0435C28.3716 20.0814 27.2228 21.1902 25.3148 21.1902ZM33.0674 14.0975C34.9055 14.0975 36.0444 15.0365 36.0444 16.585C36.0444 18.1234 34.9055 19.0724 33.0674 19.0724H31.489V21.0903H30.1904V14.0975H33.0674ZM33.0075 17.9735C34.1463 17.9735 34.7357 17.4641 34.7357 16.585C34.7357 15.7059 34.1463 15.1964 33.0075 15.1964H31.489V17.9735H33.0075ZM37.3412 21.0903V14.0975H38.6399V19.9915H42.2962V21.0903H37.3412ZM46.4613 21.1902C44.2935 21.1902 42.6951 19.6618 42.6951 17.5939C42.6951 15.526 44.2935 13.9976 46.4613 13.9976C48.629 13.9976 50.2274 15.5161 50.2274 17.5939C50.2274 19.6718 48.629 21.1902 46.4613 21.1902ZM46.4613 20.0514C47.8698 20.0514 48.9187 19.0225 48.9187 17.5939C48.9187 16.1654 47.8698 15.1364 46.4613 15.1364C45.0527 15.1364 44.0038 16.1654 44.0038 17.5939C44.0038 19.0225 45.0527 20.0514 46.4613 20.0514ZM56.741 21.0903L56.0417 19.472H52.5453L51.856 21.0903H50.5174L53.6642 14.0975H54.9429L58.0996 21.0903H56.741ZM52.9849 18.453H55.6122L54.2935 15.3962L52.9849 18.453ZM58.9889 21.0903V14.0975H62.0458C64.3135 14.0975 65.8619 15.4961 65.8619 17.5939C65.8619 19.6918 64.3135 21.0903 62.0458 21.0903H58.9889ZM60.2876 19.9915H61.9859C63.5443 19.9915 64.5532 19.0424 64.5532 17.5939C64.5532 16.1454 63.5443 15.1964 61.9859 15.1964H60.2876V19.9915Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1549_2916",
    x: 0.44397,
    y: 0.725098,
    width: 86.1619,
    height: 38.7102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.49744
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24872
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1549_2916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1549_2916",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8446c38e999c6c5d5eb2d7f473770693.svg";
export { ForwardRef as ReactComponent };